import {
  ApolloError,
  OperationVariables,
  QueryHookOptions,
  QueryResult,
  useQuery as useApolloQuery,
} from '@apollo/client';
import { DocumentNode } from 'apollo-link/lib/types';

import { useGraphQLErrorHandler } from '@sbu/hooks.graphqlerrorhandler';

type QueryOptions = {
  notifyErrors?: ((error: ApolloError) => boolean) | boolean;
};

export const useQuery = <
  TData = any,
  TVariables extends OperationVariables = OperationVariables
>(
  query: DocumentNode,
  options?: QueryHookOptions<TData, TVariables> & QueryOptions
): QueryResult<TData, TVariables> => {
  const { notifyErrors = true } = options || {};
  const result = useApolloQuery<TData, TVariables>(query, {
    errorPolicy: 'all',
    ...(options || {}),
  });

  useGraphQLErrorHandler({
    error: result.error,
    loading: result.loading,
    notifyErrors,
    stopPolling: result.stopPolling,
  });

  return result;
};
